import React, { Fragment, useContext, useEffect, useState } from "react";
import AllReviews from "./AllReviews";
import ReviewForm from "./ReviewForm";

import { ProductDetailsContext } from "./";
import { LayoutContext } from "../layout";

import { isAuthenticate } from "../auth/fetchApi";

import "./style.css";

const Menu = () => {
  const { data, dispatch } = useContext(ProductDetailsContext);
  const { data: layoutData } = useContext(LayoutContext);

  return (
    <Fragment>
    <div className="flex items-center justify-center space-x-4 md:space-x-8">
  {/* Onglet Avis */}
<div
  onClick={() => dispatch({ type: "menu", payload: true })} 
  className={`px-4 py-3 relative flex items-center cursor-pointer text-lg font-medium transition-colors duration-200
              ${data.menu ? "border-b-2 border-yellow-700 text-yellow-700" : "text-gray-800 hover:text-gray-800"}`}
>
  <span>Avis</span>
  <span
    className="absolute -top-1 right-0 transform translate-x-1/2 px-2 py-0.5 text-xs font-semibold rounded-full bg-yellow-700 text-white"
  >
    {layoutData.singleProductDetail.pRatingsReviews.length}
  </span>
</div>

{/* Onglet Description */}
<div
  onClick={() => dispatch({ type: "menu", payload: false })} 
  className={`px-4 py-3 cursor-pointer text-lg font-medium transition-colors duration-200
              ${!data.menu ? "border-b-2 border-yellow-700 text-yellow-700" : "text-gray-600 hover:text-gray-800"}`}
>
  Description
</div>

  
     
  
    </div>
  </Fragment>
  );
};

const RatingReview = () => {
  return (
    <Fragment>
      <AllReviews />
      {isAuthenticate() ? (
        <ReviewForm />
      ) : (
        <div className="mb-12 md:mx-16 lg:mx-20 xl:mx-24 bg-red-200 px-4 py-2 rounded mb-4">
          Connectez-vous pour envoyer un avis
        </div>
      )}
    </Fragment>
  );
};
// removed unused initialState to satisfy eslint

const ProductDetailsSectionTwo = (props) => {
  const { data } = useContext(ProductDetailsContext);
  const { data: layoutData } = useContext(LayoutContext);
  const [singleProduct, setSingleproduct] = useState({});

  useEffect(() => {
    setSingleproduct(
      layoutData.singleProductDetail ? layoutData.singleProductDetail : ""
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <section className="m-4 md:mx-12 md:my-8">
        <Menu />
        {data.menu ? (
          <RatingReview /> 
        ) : (
          <div className="mt-6">{singleProduct.pDescription}</div>
        )}
      </section>
      <div className="m-4 md:mx-8 md:my-6 flex justify-center capitalize font-light tracking-widest bg-white border-t border-b text-gray-800 px-4 py-4 space-x-4">
        <div>
          <span>Catégorie :</span>
          <span className="text-sm text-gray-600">
            {" "}
            {singleProduct.pCategory ? singleProduct.pCategory.cName : ""}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductDetailsSectionTwo;
